module.exports = __webpack_public_path__ + "static/media/UI_img6.e5bc385e.png";